// Mock telemetry data for the interactive demo dashboard.
// Numbers are illustrative — they match a plausible Model 3 LR pack at ~88k miles.

export const DEMO_VEHICLE = {
  model: "Tesla Model 3 Long Range",
  year: 2021,
  vin: "5YJ3E1EB7MF••••42",
  color: "Pearl White",
  odometer: 88412,
  lastSync: "2 min ago",
};

export const DEMO_HEALTH = {
  current: 89.4, // percent State-of-Health
  warrantyFloor: 70,
  fleetAverage: 91.1,
  delta30d: -0.4,
  rangeEpa: 358,
  rangeNow: 320,
  rangeLost: 38,
};

// 18 months of monthly SoH datapoints
export const DEMO_DEGRADATION = [
  { month: "Jul '24", soh: 94.1, fleet: 95.0 },
  { month: "Aug '24", soh: 93.8, fleet: 94.7 },
  { month: "Sep '24", soh: 93.4, fleet: 94.3 },
  { month: "Oct '24", soh: 93.0, fleet: 94.0 },
  { month: "Nov '24", soh: 92.5, fleet: 93.6 },
  { month: "Dec '24", soh: 92.1, fleet: 93.2 },
  { month: "Jan '25", soh: 91.8, fleet: 92.9 },
  { month: "Feb '25", soh: 91.4, fleet: 92.6 },
  { month: "Mar '25", soh: 91.0, fleet: 92.3 },
  { month: "Apr '25", soh: 90.7, fleet: 92.0 },
  { month: "May '25", soh: 90.3, fleet: 91.8 },
  { month: "Jun '25", soh: 90.0, fleet: 91.6 },
  { month: "Jul '25", soh: 89.8, fleet: 91.4 },
  { month: "Aug '25", soh: 89.7, fleet: 91.3 },
  { month: "Sep '25", soh: 89.6, fleet: 91.2 },
  { month: "Oct '25", soh: 89.5, fleet: 91.2 },
  { month: "Nov '25", soh: 89.4, fleet: 91.1 },
  { month: "Dec '25", soh: 89.4, fleet: 91.1 },
];

// Charging session efficiency over the last 30 days (kWh delivered vs. kWh stored)
export const DEMO_CHARGE_EFFICIENCY = [
  { day: "12/01", supercharger: 92, home: 88 },
  { day: "12/03", supercharger: 91, home: 89 },
  { day: "12/05", supercharger: 90, home: 89 },
  { day: "12/07", supercharger: 93, home: 87 },
  { day: "12/10", supercharger: 91, home: 88 },
  { day: "12/13", supercharger: 89, home: 90 },
  { day: "12/16", supercharger: 90, home: 88 },
  { day: "12/19", supercharger: 92, home: 89 },
  { day: "12/22", supercharger: 91, home: 88 },
  { day: "12/25", supercharger: 90, home: 87 },
  { day: "12/28", supercharger: 89, home: 89 },
];

export const DEMO_RECENT_SESSIONS = [
  { time: "Today · 08:14", type: "AC · Home", kwh: 38.2, soc: "42 → 80%", efficiency: 89 },
  { time: "Yesterday · 19:02", type: "DC · Supercharger", kwh: 41.7, soc: "18 → 80%", efficiency: 91 },
  { time: "Dec 16 · 11:48", type: "AC · Home", kwh: 22.1, soc: "55 → 80%", efficiency: 88 },
  { time: "Dec 14 · 14:30", type: "DC · Supercharger", kwh: 45.0, soc: "12 → 80%", efficiency: 90 },
];
